import React from 'react';
import { withRouter } from 'react-router';
import qs from 'query-string';

// Components
import MUITablePagination, { TablePaginationBaseProps } from '@material-ui/core/TablePagination';
import TableCell from './TableCell';

// Style
import withStyles from '@material-ui/core/styles/withStyles';

interface Props extends TablePaginationBaseProps {
  pagination?: any;
  classes: any;
  history: any;
  location: any;
  match: any;
  staticContext?: any;
  component?: React.ElementType;
}

function TablePagination({
  pagination,
  history,
  location,
  match,
  staticContext,
  component = TableCell,
  ...otherProps
}: Props) {
  const handleChangeRowsPerPage = (event: any) => {
    let query = qs.parse(history.location.search) as any;
    query.page = 1;
    query.pageSize = event.target.value;

    history.push(`${history.location.pathname}?${qs.stringify(query)}`);
  };

  const handleChangePage = (_: any, page: number) => {
    const query = qs.parse(history.location.search) as any;
    query.page = page + 1;

    history.push(`${history.location.pathname}?${qs.stringify(query)}`);
  };

  return (
    <MUITablePagination
      count={Number(pagination.total)}
      component={component}
      rowsPerPage={pagination.pageSize}
      page={pagination.page - 1}
      rowsPerPageOptions={[30, 50, 100]}
      onChangePage={handleChangePage}
      onChangeRowsPerPage={handleChangeRowsPerPage}
      {...otherProps}
    />
  );
}

const styles = (theme: any) => {
  return {
    root: {
      fontSize: '0.75rem',
    },
  };
};

export default withRouter(withStyles(styles)(TablePagination));
